// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"55":"9b06760a","69":"414b674d","113":"4b5a60b3","223":"40fb6f91","239":"76dd5d37","512":"b5125f99","596":"1e06d66b","732":"d1f3738b","746":"bb24fcb3","884":"5b884e3f","941":"988c7256","977":"8078419f"}[chunkId] + ".chunk.js";
};